import { render, staticRenderFns } from "./QuickQuery.vue?vue&type=template&id=2ba47052&scoped=true"
import script from "./QuickQuery.vue?vue&type=script&lang=js"
export * from "./QuickQuery.vue?vue&type=script&lang=js"
import style0 from "./QuickQuery.vue?vue&type=style&index=0&id=2ba47052&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba47052",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba47052')) {
      api.createRecord('2ba47052', component.options)
    } else {
      api.reload('2ba47052', component.options)
    }
    module.hot.accept("./QuickQuery.vue?vue&type=template&id=2ba47052&scoped=true", function () {
      api.rerender('2ba47052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TalentQuery/SearchPage/QuickQuery.vue"
export default component.exports